import React from 'react';
import ConfirmationModal from '../../atoms/ConfirmationModal';
import CustomButton from '../../atoms/CustomButton/CustomButton';
import { Crown } from "lucide-react";

const UpgradePromptModal = ({
  show,
  handleClose,
  featureName,
  requiredPlan
}) => {
  const message = (
    <div className="flex flex-col items-center gap-4">
      <Crown className="text-[#F97316]" size={28} />
      <div className="text-center">
        <h3 className="text-[20px] font-semibold text-[#1E3A8A] mb-2">
          Upgrade Required
        </h3>
        <p className="text-[14px] text-[#4B5563]">
          {featureName} is available in the {requiredPlan} plan and above.
          Upgrade your plan to access this feature and many more!
        </p>
      </div>
    </div>
  );

  const handleUpgrade = () => {
    window.open('https://buildtrack.ca/#subscription', '_blank', 'noopener,noreferrer');
  };

  return (
    <ConfirmationModal
      show={show}
      handleClose={handleClose}
      handleConfirm={handleUpgrade}
      loading={false}
      message={message}
      confirmText="Upgrade Now"
      confirmBgColor="#F97316"
    />
  );
};

export default UpgradePromptModal; 